import React from "react";
import style from "css/workspace.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";

function Main() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const composeList = [
    {
      id: 1,
      title: "가상 리셉셔니스트",
      link: "smart-space/work/reception",
      img: "img/smartspace/worspacemaincardimg1.png",
      img_m: "img/smartspace/worspacemaincardimg1_m.png",
    },
    {
      id: 2,
      title: "자율 좌석 시스템",
      link: "smart-space/work/hotdesk",
      img: "img/smartspace/worspacemaincardimg2.png",
      img_m: "img/smartspace/worspacemaincardimg2_m.png",
    },
    {
      id: 3,
      title: "회의실 예약 시스템",
      link: "smart-space/work/conference",
      img: "img/smartspace/worspacemaincardimg3.png",
      img_m: "img/smartspace/worspacemaincardimg3_m.png",
    },
    {
      id: 4,
      title: "화상회의 시스템",
      link: "smart-space/work/videoconference",
      img: "img/smartspace/worspacemaincardimg4.png",
      img_m: "img/smartspace/worspacemaincardimg4_m.png",
    },
    {
      id: 5,
      title: "스마트 워크 플랫폼",
      link: "smart-space/work/platform",
      img: "img/smartspace/worspacemaincardimg5.png",
      img_m: "img/smartspace/worspacemaincardimg5_m.png",
    },
    {
      id: 6,
      title: "무선 프레젠테이션 시스템",
      link: "smart-space/work/presentation",
      img: "img/smartspace/worspacemaincardimg6.png",
      img_m: "img/smartspace/worspacemaincardimg6_m.png",
    },
  ];
  const composeList2 = [
    {
      id: 1,
      title: "개인 사무실",
      subtitle: "개인룸, 임직원",
      link: "smart-space/work/videoconference/individual",
      img:
        !isMobile && !isTablet
          ? "img/smartspace/worspacemaincardimg7.png"
          : "img/smartspace/worspacemaincardimg7_m.png",
    },
    {
      id: 2,
      title: "중소형 회의실",
      subtitle: "최대 10명",
      link: "smart-space/work/videoconference/small",
      img:
        !isMobile && !isTablet
          ? "img/smartspace/worspacemaincardimg8.png"
          : "img/smartspace/worspacemaincardimg8_m.png",
    },
    {
      id: 3,
      title: "대형 회의실",
      subtitle: "10명 이상",
      link: "smart-space/work/videoconference/large",
      img:
        !isMobile && !isTablet
          ? "img/smartspace/worspacemaincardimg9.png"
          : "img/smartspace/worspacemaincardimg9_m.png",
    },
    {
      id: 4,
      title: "공용라운지 및 오피스",
      subtitle: "공유 공간, 아이데이션 회의실",
      link: "smart-space/work/videoconference/lounge",
      img:
        !isMobile && !isTablet
          ? "img/smartspace/worspacemaincardimg10.png"
          : "img/smartspace/worspacemaincardimg10_m.png",
    },
  ];

  const cardList = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img1.png",
      title1: "Powerful API Integration Support",
      title2: "강력한 API 연동 지원",
      txt: (
        <div>
          {" "}
          리브테크놀로지의 Be Gate(Gateway)는 손쉬운 API 연동을 통해 병원
          <br />
          정보시스템과 Zoom 및 WebEx와의 원활한 통합을 지원합니다. 이는
          <br />
          기존 시스템과의 호환성을 높이고, 추가 개발 비용을 절감합니다.
        </div>
      ),
      component: [
        { txt: "Be Gate (Gateway)", type: true, link: "" },
        { txt: "API 연동", type: false, link: "" },
        { txt: "Zoom / Webex", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img1.png",
      title1: "Comprehensive Multi-Function Platform",
      title2: "다양한 기능의 통합 플랫폼",
      txt: (
        <div>
          리브테크놀로지의 솔루션은 원격 진료, 협진, 의료 세미나 등 다양한
          기능을
          <br />
          하나의 플랫폼에 통합하여 제공합니다. 이는 의료진과 환자가 하나의
          <br />
          시스템에서 모든 진료 활동을 관리할 수 있게 하여 사용 편의성을
          극대화합니다.
        </div>
      ),
      component: [
        {
          txt: "원격 진료 | 원격 협진 | 의료 세미나",
          type: true,
          link: "",
        },
        { txt: "통합 플랫폼", type: false, link: "" },
      ],
    },
  ];

  return (
    <>
      <SEOMeta
        title="스마트 워크 스페이스, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 스마트 워크 스페이스"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 
        스마트 워크 스페이스, 가상 리셉셔니스트, 
        자율좌석제, 회의실 예약 시스템, 화상회의 시스템"
      />
      <div className={style.wrapper}>
        <div className={style.mainImg}>
          <div className={style.mainTxt}>
            <p>{"뉴노멀 AI 시대, \n앞으로 다가올 미래 오피스의 기준"}</p>
            <p>리브테크놀로지</p>
            <p>Smart Work Space</p>
          </div>

          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemain.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemain_m.png`
            }
          />
        </div>
        <div className={style.mainEx}>
          <div className={style.mainExTxt}>
            <p>스마트 워크 스페이스</p>
            <p>Smart Work Space</p>
            <p>
              {
                "업무의 생산성 · 효율성을 높이는 공간 기획으로\nSmart한 근무 환경을 만드세요."
              }
            </p>
          </div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemainex.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemainex_m.png`
            }
          />
          <div className={style.mainExCardList}>
            {!isMobile && !isTablet ? (
              <>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>1</p>
                  <p className={style.exListTxt}>가상 리셉셔니스트</p>
                </div>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>2</p>
                  <p className={style.exListTxt}>자율좌석제 예약 화면</p>
                </div>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>3</p>
                  <p className={style.exListTxt}>자율좌석제</p>
                </div>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>4</p>
                  <p className={style.exListTxt}>
                    일반회의실 및 예약 / 스케줄러
                  </p>
                </div>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>5</p>
                  <p className={style.exListTxt}>
                    화상회의실 및 예약 / 스케줄러
                  </p>
                </div>
                <div className={style.mainExCardItem}>
                  <p className={style.exListNum}>6</p>
                  <p className={style.exListTxt}>공용 라운지</p>
                </div>
              </>
            ) : (
              <>
                <div className={style.mainExCardRow}>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>1</p>
                    <p className={style.exListTxt}>가상 리셉셔니스트</p>
                  </div>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>2</p>
                    <p className={style.exListTxt}>자율좌석제 예약 화면</p>
                  </div>
                </div>
                <div className={style.mainExCardRow}>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>3</p>
                    <p className={style.exListTxt}>자율좌석제</p>
                  </div>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>4</p>
                    <p className={style.exListTxt}>
                      일반회의실 및 예약 / 스케줄러
                    </p>
                  </div>
                </div>
                <div className={style.mainExCardRow}>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>5</p>
                    <p className={style.exListTxt}>
                      화상회의실 및 예약 / 스케줄러
                    </p>
                  </div>
                  <div className={style.mainExCardItem}>
                    <p className={style.exListNum}>6</p>
                    <p className={style.exListTxt}>공용 라운지</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className={style.mainComposeWrap}>
          <div className={style.mainCompose}>
            <div className={style.mainComposeTxt}>
              <p>구성환경 Ⅰ</p>
              <p>
                <font>협업</font>을 위한 공간 구성
              </p>
              <p>
                {
                  "효율적인 소통과 협력을 촉진하는\n 맞춤형 공간 솔루션으로 팀워크를 강화하세요."
                }
              </p>
            </div>
            <div className={style.composeList}>
              {composeList.map((item) => (
                <div className={style.composeCard + " cursor"}>
                  <Link to={`${process.env.REACT_APP_CLIENT_URL + item.link}`}>
                    <img
                      className={style.composeCardImg}
                      alt=""
                      src={
                        !isMobile && !isTablet
                          ? `${process.env.REACT_APP_CLIENT_URL + item.img}`
                          : `${process.env.REACT_APP_CLIENT_URL + item.img_m}`
                      }
                    />
                    <div>
                      <p>{item.title}</p>
                      <p>
                        <font>More</font>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={style.mainComposeWrap2}>
          <div className={style.mainCompose}>
            <div className={style.mainComposeTxt}>
              <p>구성환경 Ⅱ</p>
              <p>
                <font>규모</font>에 맞는 공간 구성
              </p>
              <p>기업 환경에 맞춘, 특성에 맞춘 근무환경을 제안해 드립니다.</p>
            </div>
            <div className={style.composeList2}>
              {composeList2.map((item) => (
                <div className={style.composeCard2 + " cursor"}>
                  <Link to={`${process.env.REACT_APP_CLIENT_URL + item.link}`}>
                    <img
                      className={style.composeCardImg}
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + item.img}
                    />
                    <div>
                      <p>
                        <font>{item.title}</font>
                        <font>{item.subtitle}</font>
                      </p>
                      {!isMobile && !isTablet ? (
                        <p>
                          <font>More</font>
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` +
                              "img/smartspace/arrowRight.png"
                            }
                          />
                        </p>
                      ) : (
                        <p>
                          <button>
                            <font>More</font>
                            <img
                              alt=""
                              src={
                                `${process.env.REACT_APP_CLIENT_URL}` +
                                "img/smartspace/arrowRight.png"
                              }
                            />
                          </button>
                        </p>
                      )}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={style.mainImg2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/workspacemain2.png')",
          }}
        >
          <div className={style.main2Txt}>
            <div>
              <p>
                업무 형태·상황에 따른 <font>최적의 공간</font>이 필요합니다.
              </p>
              {!isMobile && !isTablet ? (
                <p>
                  다양한 포지션의 <font> 직원들이 근무하고 협업</font>하는데
                  최적의 공간을 구축하세요.
                </p>
              ) : (
                <p>
                  다양한 포지션의 <font> 직원들이 근무하고 협업</font>하는데
                  <br />
                  최적의 공간을 구축하세요.
                </p>
              )}
            </div>
            <img
              alt=""
              src={
                !isMobile && !isTablet
                  ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemain3.png`
                  : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/workspacemain3_m.png`
              }
            />
            <div>
              {!isMobile && !isTablet ? (
                <p>
                  <font>가장 일이 잘 되는 곳,</font> 미래의 업무공간 입니다.
                </p>
              ) : (
                <p>
                  <font>가장 일이 잘 되는 곳,</font>
                  <br />
                  미래의 업무공간 입니다.
                </p>
              )}
            </div>
          </div>
        </div>
        {/* <div className={style.clients}>
          <div className={style.clientsHeader}>
            <p>Clients and Partners</p>
            <p>
              2012년부터 리브테크놀로지와 많은 기업/기관/학교들이 함께했습니다.
            </p>
          </div>
          <div className={style.clientsInfo}>
            <div>
              <p>
                <font>89</font>
                <font>+</font>
              </p>
              <p>사용 기관</p>
            </div>
            <div />
            <div>
              <p>
                <font>568,676</font>
                <font>+</font>
              </p>
              <p>연 사용 인원</p>
            </div>
          </div>
          <div className={style.clientsMore}>
            <p>More view Clients</p>
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/arrowRight.png"
              }
            />
          </div>
        </div> */}
        <Questions />
      </div>
    </>
  );
}

export default Main;
